module.exports = __webpack_public_path__ + "static/img/index-bg.8f75cf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index-bg.png
// module id = Q17V
// module chunks = 1